import axios from "axios";

const runtimeEnv = import.meta.env || {};
const publicBaseUrl = (runtimeEnv.VITE_API_BASE_URL || "").replace(/\/$/, "");
let getAccessToken = () => null;
let handleUnauthorized = () => {};
let getRefreshToken = () => null;
let handleTokenRefreshed = () => {};
let refreshPromise = null;

export const apiClient = axios.create({
  baseURL: `${publicBaseUrl}/api/v1`,
  timeout: 15_000,
});

export function configureHttpAuth({ getToken, getRefresh, onTokenRefreshed, onUnauthorized } = {}) {
  getAccessToken = getToken || (() => null);
  getRefreshToken = getRefresh || (() => null);
  handleTokenRefreshed = onTokenRefreshed || (() => {});
  handleUnauthorized = onUnauthorized || (() => {});
}

apiClient.interceptors.request.use((config) => {
  const accessToken = getAccessToken();
  if (accessToken) {
    config.headers.Authorization = `Bearer ${accessToken}`;
  }
  return config;
});

apiClient.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    const shouldRefresh = error.response?.status === 401
      && originalRequest
      && !originalRequest._retry
      && !String(originalRequest.url || "").includes("/auth/token/refresh/")
      && Boolean(getRefreshToken());

    if (!shouldRefresh) {
      if (error.response?.status === 401) handleUnauthorized();
      return Promise.reject(error);
    }

    originalRequest._retry = true;
    try {
      refreshPromise ||= apiClient.post("/auth/token/refresh/", { refresh: getRefreshToken() });
      const response = await refreshPromise;
      refreshPromise = null;
      const access = response.data?.access;
      if (!access) throw new Error("刷新令牌响应缺少 access token");
      handleTokenRefreshed(access);
      originalRequest.headers = originalRequest.headers || {};
      originalRequest.headers.Authorization = `Bearer ${access}`;
      return apiClient(originalRequest);
    } catch (refreshError) {
      refreshPromise = null;
      handleUnauthorized();
      return Promise.reject(refreshError);
    }
  },
);

export function createIdempotencyKey(scope) {
  return `${scope}:${crypto.randomUUID()}`;
}
